import { api } from "./configs/axiosConfigs"
import { defineCancelApiObject } from "./configs/axiosUtils"

export const ImportAPI = {

  import: async function (data, url, cancel = false) {
    const response = await api.request({
      url: 'import/' + url,
      method: "POST",
      data: data,
      signal: cancel ? cancel : undefined,
    })

    return response.data
  },

  getImportStatus: async function (id, cancel = false) {
    const response = await api.request({
      url: `imports/${id}/status`,
      method: "GET",
      signal: cancel ? cancel : undefined,
    });

    return response.data;
  },

}



// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(ImportAPI)